export const SHC_ACTIONS = {
  CHART_LOADED: "SHC_CHART_LOADED",
  FETCH_DATA: "FETCH_SHC_GRAPH_WIDGET_DATA"
};

export const onSHCChartLoad = () => ({
  type: SHC_ACTIONS.CHART_LOADED
});